/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable no-loss-of-precision */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Row, Radio, Col, Button, message, Spin } from "antd";
import PropTypes from "prop-types";
import {
  clearUpdateShipment,
  updateShipment,
  clearCreateChildShipment,
  clearChildPacketIds,
} from "../../actionsMethods/cashBookingMethods";
import BookingSummary from "../BookingSummary";
import ConstantsMsgs from "../../constants/messages";
import walletIcon from "../../assests/images/SVG/walletIcon.svg";
import UpiIcon from "../../assests/images/SVG/UPIICon.svg";
import "./style.scss";
import { APIs, getToken } from "../../utils/worker";
import axios from "axios";
const Payment = ({ screen, currentScreen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [details, setDetails] = useState();
  const [userIdData, setUserIdData] = useState();
  const [calculatedFreight, setCalculatedFreight] = useState(details?.freight);
  const [radioCheck, setRadioCheck] = useState(null);
  const [filesData, setFileData] = useState([]);
  const [filesLength, setFileLength] = useState([]);
  const [destinationDetails, setdestinationDetails] = useState([]);
  const token = getToken();

  const allAppData = JSON.parse(localStorage.getItem("details"));
  const getUpdateShipmentResponse = useSelector(
    (state) => state.appReducer.getUpdateShipmentReducer
  );
  const { result, error, fetching } = getUpdateShipmentResponse;

  useEffect(() => {
    window.scrollTo(0, 0);
    setUserIdData(JSON.parse(localStorage.getItem("userId")));
  }, [currentScreen]);

  useEffect(() => {
    setFileData(JSON.parse(localStorage.getItem("allFiles")));
    setFileLength(JSON.parse(localStorage.getItem("filesLength")));
    if (currentScreen == 4) {
      getDestinationId();
    }
  }, [screen]);

  useEffect(() => {
    setCalculatedFreight(details?.freight);
    setDetails(JSON.parse(localStorage.getItem("details")));
  }, [screen]);

  useEffect(() => {
    if (result !== null) {
      dispatch(clearCreateChildShipment());
      dispatch(clearChildPacketIds());
      dispatch(clearUpdateShipment());
      navigate("/booking-success");
    }
    if (error) {
      message.error(error?.message || "Booking Failed");
      dispatch(clearUpdateShipment());
    }
  }, [result, error]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const getDestinationId = async () => {
    try {
      let res = await axios.get(
        `${APIs.baseURL}/premise-service/v1/premise/pincode/${allAppData?.values?.deliveryPincode}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (res.data) {
        setdestinationDetails(res?.data);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleScreen = () => {
    if (radioCheck !== null) {
      let allAppData = JSON.parse(localStorage.getItem("details"));
      let destinationHubId = destinationDetails?.find(
        (e) => e.premiseId == allAppData?.destinationPremiseId
      );
      const {
        awbNumber,
        senderCity,
        receiverCity,
        senderName,
        senderAddressLine1,
        senderAddressLine2,
        senderState,
        senderPincode,
        senderAreaName,
        senderMobileNumber,
        receiverName,
        receiverAddressLine1,
        receiverState,
        receiverPincode,
        receiverMobilenumber,
        type,
        senderEmail,
        senderGst,
        value,
        eWayBill,
        senderPan,
        receiverAddressLine2,
        area,
        receiverEmail,
        description,
        content,
        weight,
        deliveryPincode,
        width,
        height,
        length,
        charges,
        sgst,
        cgst,
        igst,
        cess,
        freight,
        volumetricWeight,
        selectedMode,
        selectedArea,
      } = allAppData || {};

      let newdata = {
        addressDetails: {
          senderName: senderName,
          senderAddressLine1: senderAddressLine1,
          senderAddressLine2: senderAddressLine2,
          senderPincode: +senderPincode,
          senderCity: senderCity,
          senderState: senderState,
          senderMobileNumber: +senderMobileNumber,
          senderEmail: senderEmail || "",
          senderArea: senderAreaName || "",
          senderGst: senderGst,
          senderPan: senderPan,
          customerId: 1960581322055966062,
          receiverName: receiverName,
          receiverAddressLine1: receiverAddressLine1,
          receiverAddressLine2: receiverAddressLine2,
          receiverCity: receiverCity,
          receiverPincode: +receiverPincode,
          receiverState: receiverState,
          receiverAreaId: selectedArea?.id,
          receiverAreaName: area,
          receiverMobileNumber: +receiverMobilenumber,
          receiverEmail: receiverEmail || "",
        },
        shipmentDetails: {
          type: type,
          description: description,
          content: content,
          value: +value || 0,
          weight: +weight || null,
          width: +width || null,
          height: +height || null,
          length: +length || null,
          ewayBillNumber: eWayBill,
          destinationPincode: +deliveryPincode,
          service: 1,
          destinationCpId: allAppData?.destinationPremiseId,
          destinationHubId: destinationHubId?.parentId,
          premiseId: userIdData?.data?.premiseId,
          userID: userIdData?.userInfo?.userId,
          bookingType: "Cash",
          volumetricWeight: +volumetricWeight,
        },
        serviceDetails: {
          service: selectedMode?.mode,
          travelBy: selectedMode?.type,
        },
        charges: {
          charges: +charges,
          sgst: sgst,
          cgst: cgst,
          cess: cess,
          freight: freight,
          igst: igst,
          promotionId: 1,
          discount: 10.5,
        },
        file: filesData?.length
          ? filesData?.map((val) => ({
              fileName: val?.filePath,
              fileId: val?.id,
            }))
          : [],
        bookingStatus: "UPDATED",
        local: false,
      };

      dispatch(updateShipment(newdata, awbNumber));
    }
  };

  const handleBack = () => {
    return screen(3);
  };

  const onSubmitFormData = (values) => {
    let newDetails = { ...details, ...values };
    localStorage.setItem("details", JSON.stringify(newDetails));
  };

  const formProps = {
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };

  const onRadioChange = (e) => {
    setRadioCheck(e.target.value);
  };

  return (
    <>
      <BookingSummary
        visible={isModalOpen}
        handleCancel={handleCancel}
        allAppData={details}
        insurance={calculatedFreight}
      />
      <Spin spinning={fetching}>
        <Form {...formProps} form={form} scrollToFirstError={true}>
          <div className="payment-form">
            <Row className="mainForm">
              <Col
                md={24}
                lg={11}
                sm={24}
                xs={24}
                xl={11}
                offset={1}
                className="left"
              >
                <h3>{ConstantsMsgs?.PAYMENT_MESSAGE_ONE}</h3>
                <div>
                  <Form.Item
                    name="radio"
                    rules={[
                      {
                        required: true,
                        message: "Please select a payment option",
                      },
                    ]}
                    className={"radio-group-container"}
                  >
                    <Radio.Group
                      className={"radio-group-container"}
                      onChange={onRadioChange}
                    >
                      <div span={24} className={"radio-items"}>
                        <Row className="">
                          <div className="row-card">
                            <Radio value={"Cash"}>
                              <div className="radio_container">{"Cash"}</div>
                            </Radio>
                            <img src={walletIcon} />
                          </div>
                          <div
                            className="row-card"
                            style={{ padding: "15px 10px" }}
                          >
                            <Radio value={"UPI"}>
                              <div className="radio_container">{"UPI"}</div>
                            </Radio>
                            <img src={UpiIcon} />
                          </div>
                        </Row>
                      </div>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </Col>
              <Col md={24} lg={11} sm={24} xs={24} xl={11} offset={1}>
                <div className="bill-details">
                  <h3 className="bill-label">{ConstantsMsgs?.BILL_DETAILS}</h3>
                  <Row>
                    <Col span={20}>
                      <p>{ConstantsMsgs?.TOTAL_CHARGES}</p>
                    </Col>
                    <Col span={4}>
                      <p>{allAppData?.charges}</p>
                    </Col>

                    <Col span={20}>
                      <p>{ConstantsMsgs?.SGST}</p>
                    </Col>
                    <Col span={4}>
                      <p>{details?.sgst || "00.00"}</p>
                    </Col>

                    <Col span={20}>
                      <p>{ConstantsMsgs?.CGST}</p>
                    </Col>
                    <Col span={4}>
                      <p>{details?.cgst || "00.00"}</p>
                    </Col>

                    <Col span={20}>
                      <p>{ConstantsMsgs?.IGST}</p>
                    </Col>
                    <Col span={4}>
                      <p>{details?.igst || "00.00"}</p>
                    </Col>

                    <Col span={20}>
                      <p>{ConstantsMsgs?.CESS}</p>
                    </Col>

                    <Col span={4}>
                      <p>{details?.cess || "00.00"}</p>
                    </Col>

                    <Col span={20} className="total">
                      <h3>{ConstantsMsgs?.FRIEGHT}</h3>
                    </Col>

                    <Col span={4} className="total">
                      <h3>{details?.freight}</h3>
                    </Col>
                  </Row>
                </div>

                <Row className="click-info">
                  <p>
                    <span
                      onClick={() => showModal()}
                      className="pointer"
                      style={{ color: " #1890ff" }}
                    >
                      {ConstantsMsgs?.CLICK_HERE}
                    </span>{" "}
                    &nbsp;{ConstantsMsgs?.PAYMENT_MESSAGE_TWO}
                  </p>
                  <p className="click-info-para"></p>
                </Row>
              </Col>
            </Row>
            <Row className="button-container">
              <Col span={24}>
                <div className="steps-action">
                  <Button onClick={() => handleBack()} className="back-button">
                    {"BACK"}
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={handleScreen}
                    className="next-button"
                  >
                    {"SUBMIT"}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </Form>
      </Spin>
    </>
  );
};

export default Payment;
Payment.PropTypes = {
  screen: PropTypes.number,
  currentScreen: PropTypes.number,
};
